import { Avatar, Clickable, Col, Dropdown, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { SearchUsers } from 'screens/Admin/components';

const sportOptions = [
  {
    value: 'All'
  },
  {
    value: 'American Football',
    opt: 'americanFootball'
  },
  {
    value: 'Baseball',
    opt: 'baseball'
  },
  {
    value: 'Basketball',
    opt: 'basketball'
  },
  {
    value: 'Soccer',
    opt: 'soccer'
  }
  /*
  {
    value: 'Boxing',
    opt: 'boxing'
  },
  {
    value: 'Cricket',
    opt: 'cricket'
  },
  {
    value: 'MMA',
    opt: 'mma'
  },
  {
    value: 'Car Race',
    opt: 'carRace'
  },
  {
    value: 'Tennis',
    opt: 'tennis'
  },
   */
];

const Filters = ({ sport, setSport, team, setTeam, athlete, setAthlete }) => {
  return (
    <Row start gap="30px" pad="12px 24px" noFlex>
      <Dropdown
        admin
        title="Filter by Sport"
        wid="200px"
        selected={sport.value}
        options={sportOptions}
        handleSelect={setSport}
        rounded
        small
      />

      <Col noFlex>
        <Text marg="0 16px 4px" b2 med col={athlete ? theme.GREY_40 : undefined}>
          Filter by Team
        </Text>
        <Row noFlex wid="300px">
          <SearchUsers
            userType="team"
            selected={team}
            handleSelect={setTeam}
            includeDummy={true}
            noRounded
            disabled={Boolean(athlete)}
          />

          {team && (
            <Row start between wid="100%" center>
              <Row noFlex center>
                <Avatar small user={team} />

                <Col marg="0 0 0 8px" noFlex ht="40px">
                  <Text>{team.name}</Text>
                </Col>
              </Row>

              <Clickable onClick={() => setTeam(null)}>
                <Icon type="close" dimensions={14} />
              </Clickable>
            </Row>
          )}
        </Row>
      </Col>

      <Col noFlex>
        <Text marg="0 16px 4px" b2 med col={team ? theme.GREY_40 : undefined}>
          Filter by Athlete
        </Text>
        <Row noFlex wid="300px">
          <SearchUsers
            userType="athlete"
            selected={athlete}
            handleSelect={setAthlete}
            noRounded
            disabled={Boolean(team)}
          />

          {athlete && (
            <Row start between wid="100%" center>
              <Row noFlex center>
                <Avatar small user={athlete} />

                <Col marg="0 0 0 8px" noFlex>
                  <Text>{athlete?.name}</Text>

                  <Text c1 col={theme.GREY_60}>
                    @{athlete?.username}
                  </Text>
                </Col>
              </Row>

              <Clickable onClick={() => setAthlete(null)}>
                <Icon type="close" dimensions={14} />
              </Clickable>
            </Row>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default Filters;
